

export const GetIpfsUrlFromPinata = (pinataUrl) => {
    var IPFSUrl = pinataUrl.split("/");
    const lastIndex = IPFSUrl.length;
    IPFSUrl = "https://silver-wonderful-moth-543.mypinata.cloud/ipfs/"+IPFSUrl[lastIndex-1];
    return IPFSUrl;
};